import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';

import { Message } from 'src/app/models/message';
import { Answer } from 'src/app/models/survey/answer';
import { Axis } from 'src/app/models/survey/axis';
import { Option } from 'src/app/models/survey/options';
import { Question } from 'src/app/models/survey/question';
import { Survey } from 'src/app/models/survey/survey';
import { SvSection } from 'src/app/models/survey/svsection';
import { AnswerService } from 'src/app/services/survey/answer.service';
import { AxisService } from 'src/app/services/survey/axis.service';
import { OptionsService } from 'src/app/services/survey/options.service';
import { QuestionTypeService } from 'src/app/services/survey/question-type.service';
import { QuestionService } from 'src/app/services/survey/question.service';
import { SurveyService } from 'src/app/services/survey/survey.service';
import { SvsectionService } from 'src/app/services/survey/svsection.service';
import { LinkquestionsService } from 'src/app/services/survey/linkquestions.service';
import { TrackingService } from 'src/app/services/survey/tracking.service';
import { v4 as uuidv4 } from 'uuid';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-investigation',
  templateUrl: './investigation.component.html',
  styleUrls: ['./investigation.component.scss']
})
export class InvestigationComponent implements OnInit, OnDestroy {

  enddate: Date;
  isSurveyExpired: boolean = false;
  statusMessage: string = '';
  email: string; //recepcionamos url
  currentUrl: string;
  thankYouModalInstance: any;
  form: FormGroup;
  survey: Survey = null;
  answer: Answer = null;
  svsections: SvSection[] = null;
  questions: Question[];
  opts: Option[];
  msg: Message = { status: null, message: null };
  hiddenMsg: boolean = true;
  browserName = '';
  osName = '';
  idSurvey = 0;
  answers: { [key: string]: any } = {};  // Estado de respuestas
  currentSectionIndex: number = 0;  // Índice de la sección actual
  linkQuestions: any[] = []; // Preguntas de vinculación
  hiddenSections: Set<number> = new Set();
  message = ''; // Mensaje del bocadillo
  showModal: boolean = false;
  typeEmail = 1;

  careers: { id: number, name: string }[] = [
    // Ciencias de la Salud
    { id: 1, name: 'Ciencia de los Alimentos' },
    { id: 2, name: 'Enfermería' },
    { id: 3, name: 'Farmacia y Bioquímica' },
    { id: 4, name: 'Medicina Humana' },
    { id: 5, name: 'Medicina Veterinaria' },
    { id: 6, name: 'Nutrición' },
    { id: 7, name: 'Obstetricia' },
    { id: 8, name: 'Odontología' },
    { id: 9, name: 'Psicología' },
    { id: 10, name: 'Psicología Organizacional y de la Gestión Humana' },
    { id: 11, name: 'Tecnología Médica' },
    { id: 12, name: 'Toxicología' },

    // Ciencias Básicas
    { id: 13, name: 'Ciencias Biológicas' },
    { id: 14, name: 'Computación Científica' },
    { id: 15, name: 'Estadística' },
    { id: 16, name: 'Física' },
    { id: 17, name: 'Genética y Biotecnología' },
    { id: 18, name: 'Investigación Operativa' },
    { id: 19, name: 'Matemática' },
    { id: 20, name: 'Microbiología y Parasitología' },
    { id: 21, name: 'Química' },

    // Ingeniería
    { id: 22, name: 'Ciencia de la Computación' },
    { id: 23, name: 'Ingeniería Agroindustrial' },
    { id: 24, name: 'Ingeniería Ambiental' },
    { id: 25, name: 'Ingeniería Biomédica' },
    { id: 26, name: 'Ingeniería Civil' },
    { id: 27, name: 'Ingeniería de Minas' },
    { id: 28, name: 'Ingeniería de Seguridad y Salud en el Trabajo' },
    { id: 29, name: 'Ingeniería de Sistemas' },
    { id: 30, name: 'Ingeniería de Software' },
    { id: 31, name: 'Ingeniería de Telecomunicaciones' },
    { id: 32, name: 'Ingeniería Eléctrica' },
    { id: 33, name: 'Ingeniería Electrónica' },
    { id: 34, name: 'Ingeniería Geográfica' },
    { id: 35, name: 'Ingeniería Geológica' },
    { id: 36, name: 'Ingeniería Industrial' },
    { id: 37, name: 'Ingeniería Mecánica de Fluidos' },
    { id: 38, name: 'Ingeniería Metalúrgica' },
    { id: 39, name: 'Ingeniería Química' },
    { id: 40, name: 'Ingeniería Textil y Confecciones' },

    // Ciencias Económicas y de la Gestión
    { id: 41, name: 'Administración' },
    { id: 42, name: 'Administración de Negocios Internacionales' },
    { id: 43, name: 'Administración de Turismo' },
    { id: 44, name: 'Auditoría Empresarial y del Sector Público' },
    { id: 45, name: 'Contabilidad' },
    { id: 46, name: 'Economía' },
    { id: 47, name: 'Economía Internacional' },
    { id: 48, name: 'Economía Pública' },
    { id: 49, name: 'Gestión Tributaria' },
    { id: 50, name: 'Presupuesto y Finanzas Públicas' },

    // Humanidades, Ciencias Jurídicas y Sociales
    { id: 51, name: 'Antropología' },
    { id: 52, name: 'Arqueología' },
    { id: 53, name: 'Arte' },
    { id: 54, name: 'Bibliotecología y Ciencias de la Información' },
    { id: 55, name: 'Ciencia Política' },
    { id: 56, name: 'Comunicación Social' },
    { id: 57, name: 'Conservación y Restauración' },
    { id: 58, name: 'Danza' },
    { id: 59, name: 'Derecho' },
    { id: 60, name: 'Educación' },
    { id: 61, name: 'Educación Física' },
    { id: 62, name: 'Filosofía' },
    { id: 63, name: 'Geografía' },
    { id: 64, name: 'Historia' },
    { id: 65, name: 'Lenguas, Traducción e Interpretación' },
    { id: 66, name: 'Lingüística' },
    { id: 67, name: 'Literatura' },
    { id: 68, name: 'Sociología' },
    { id: 69, name: 'Trabajo Social' },

    // Carreras adicionales de UNI
    { id: 70, name: 'Ingeniería Sanitaria' },
    { id: 71, name: 'Ingeniería Mecánica' },
    { id: 72, name: 'Ingeniería de Petróleo' },
    { id: 73, name: 'Arquitectura' }
  ];

  filteredCareers: { id: number, name: string }[] = [];
  isCareersDropdownVisible: boolean = false;


  countries: { id: number, name: string }[] = [];
  states: { id: number, id_country: number, name: string }[] = [];
  filteredCountries: { id: number, name: string }[] = [];
  filteredStates: { id: number, name: string }[] = [];
  selectedCountryId: number = null;
  isCountriesDropdownVisible: boolean = false;
  isStatesDropdownVisible: boolean = false;

  constructor(
    private http: HttpClient,
    private svService: SurveyService,
    private qtService: QuestionTypeService,
    private svsecService: SvsectionService,
    private qService: QuestionService,
    private optService: OptionsService,
    private axService: AxisService,
    private answerService: AnswerService,
    private fb: FormBuilder,
    private actRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private linkService: LinkquestionsService,
    private trackingService: TrackingService,
    private router: Router,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer
  ) { }

  getGlossaryDetail(): string {
    const glossarySection = this.survey.sections.find(section => section.title === "Glosario de términos");
    return glossarySection ? glossarySection.detail : '';
  }
  ngOnInit() {


    setTimeout(() => {
      const bubble = document.getElementById('bubble');
      const hoverMessage = document.getElementById('hoverMessage');
      const typingText = document.getElementById('typingText');

      if (bubble && hoverMessage && typingText) {
        bubble.classList.add('small-text'); // Inicialmente pequeño
        hoverMessage.classList.add('show'); // Mostrar el mensaje de hover
        this.message = this.getGlossaryDetail(); // Obtener el mensaje dinámico
        typingText.innerHTML = this.message; // Establecer el contenido del mensaje largo
      }
    }, 1000);

    // Ocultar <app-header> y <app-footer> al cargar el componente
    const header = document.querySelector('app-header');
    const footer = document.querySelector('app-footer');
    this.filteredCareers = this.careers;

    this.loadCountries();
    this.loadStates();

    if (header) {
      this.renderer.setStyle(header, 'display', 'none');
    }

    if (footer) {
      this.renderer.setStyle(footer, 'display', 'none');
    }

    const params = this.actRoute.snapshot.params;
    if (params['id']) {
      this.getOneSurvey(params['id']);
    } else if (params['url']) {
      this.getOneUrlSurvey(params['url']);
    }
    if (params['email'] && this.validateEmail(params['email'])) {
      this.email = params['email'];
      this.typeEmail = 1;
      this.currentUrl = this.removeLastUrlSegment(window.location.href);
    } else {
      this.email = this.getDeviceId();
      this.typeEmail = 0;
      this.currentUrl = window.location.href;
    }
    this.getBrowserName();
    this.getOsName();

    //obtenemos todas las preguntas que desencadenan secciones
    this.linkService.getAll().subscribe((data: any) => {
      this.linkQuestions = data.data;
      this.initializeHiddenSections();

      // Cargar respuestas desde localStorage
      const savedAnswers = localStorage.getItem('surveyAnswers_' + this.email);
      //console.log("savedAnswers: ", 'surveyAnswers_' + this.email);
      if (savedAnswers) {
        try {
          this.answers = JSON.parse(savedAnswers);
          this.restoreSectionVisibility();
        } catch (error) {
          console.error('Error al recuperar respuestas:', error);
          this.answers = {};
        }
      } else {
        this.answers = {};
      }
    });

  }

  showCompleteMessage() {
    this.toggleMessages(false);
  }

  hideMessage() {
    this.toggleMessages(true);
  }

  toggleMessages(isHovering: boolean) {
    const bubble = document.getElementById('bubble');
    const typingText = document.getElementById('typingText');
    const hoverMessage = document.getElementById('hoverMessage');

    if (typingText && hoverMessage && bubble) {
      if (isHovering) {
        typingText.classList.remove('show');
        setTimeout(() => {
          typingText.style.display = 'none';
          hoverMessage.style.display = 'block';
          hoverMessage.classList.add('show');
        }, 500); // Esperar a que se complete la transición
        bubble.classList.remove('full-text');
        bubble.classList.add('small-text');
      } else {
        hoverMessage.classList.remove('show');
        hoverMessage.style.display = 'none';
        typingText.style.display = 'block';
        setTimeout(() => {
          typingText.classList.add('show');
        }, 0); // Transición suave después de mostrar
        bubble.classList.remove('small-text');
        bubble.classList.add('full-text');
      }
    }
  }


  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  filterCareers(query: string, idquestion: number, idoption: number) {
    this.filteredCareers = this.careers.filter(career =>
      career.name.toLowerCase().includes(query.toLowerCase())
    );
    this.isCareersDropdownVisible = this.filteredCareers.length > 0;
    this.handleManualEntry(query, idquestion, idoption);
  }

  selectCareer(career: { id: number, name: string }, idquestion: number, idoption: number) {
    this.isCareersDropdownVisible = false;
    const inputElement = (document.getElementById(idoption.toString()) as HTMLInputElement);
    if (inputElement) {
      inputElement.value = career.name;
    }
    this.createAnswer(idquestion, idoption, null, null, null, career.name, 13, null);
  }

  handleManualEntry(query: string, idquestion: number, idoption: number) {
    if (!this.filteredCareers.length) {
      this.createAnswer(idquestion, idoption, null, null, null, query, 13, null);
    }
  }

  onFocusCareers() {
    this.isCareersDropdownVisible = this.filteredCareers.length > 0;
  }

  onBlurCareers() {
    setTimeout(() => { this.isCareersDropdownVisible = false; }, 200);
  }

  loadCountries(): void {
    this.http.get<{ countries: { id: number, name: string }[] }>('assets/json/countries.json')
      .subscribe(data => {
        this.countries = data.countries;
        this.filteredCountries = this.countries;
      });
  }

  loadStates(): void {
    this.http.get<{ states: { id: number, id_country: number, name: string }[] }>('assets/json/states.json')
      .subscribe(data => {
        this.states = data.states;
      });
  }

  filterCountries(query: string, idquestion: number, idoption: number): void {
    this.filteredCountries = this.countries.filter(country =>
      country.name.toLowerCase().includes(query.toLowerCase())
    );
    this.isCountriesDropdownVisible = this.filteredCountries.length > 0;
  }

  filterStates(query: string, idquestion: number, idoption: number): void {
    if (this.selectedCountryId) {
      this.filteredStates = this.states.filter(state =>
        state.id_country === this.selectedCountryId && state.name.toLowerCase().includes(query.toLowerCase())
      );
      this.isStatesDropdownVisible = this.filteredStates.length > 0;
    }
  }

  selectCountry(country: { id: number, name: string }, idquestion: number, idoption: number): void {
    this.selectedCountryId = country.id;
    this.isCountriesDropdownVisible = false;

    const countryInput = document.getElementById(idoption.toString()) as HTMLInputElement;
    if (countryInput) {
      countryInput.value = country.name;
    }

    this.filterStates('', idquestion, idoption);
    this.createAnswer(idquestion, idoption, null, null, null, country.name, 14, null);
  }

  selectState(state: { id: number, name: string }, idquestion: number, idoption: number): void {
    this.isStatesDropdownVisible = false;

    const stateInput = document.getElementById(idoption.toString()) as HTMLInputElement;
    if (stateInput) {
      stateInput.value = state.name;
    }
    this.createAnswer(idquestion, idoption, null, null, null, state.name, 15, null);

  }

  onFocusCountries(): void {
    this.isCountriesDropdownVisible = this.filteredCountries.length > 0;
  }

  onBlurCountries(): void {
    setTimeout(() => { this.isCountriesDropdownVisible = false; }, 200);
  }

  onFocusStates(): void {
    this.isStatesDropdownVisible = this.filteredStates.length > 0;
  }

  onBlurStates(): void {
    setTimeout(() => { this.isStatesDropdownVisible = false; }, 200);
  }

  getDeviceId(forceNewId: boolean = false): string {
    let deviceId = localStorage.getItem('device_id');

    if (!deviceId || forceNewId) {
      deviceId = uuidv4();
      localStorage.setItem('device_id', deviceId);
    }

    return deviceId;
  }

  ngOnDestroy() {
    // Restaurar <app-header> y <app-footer> al destruir el componente
    const header = document.querySelector('app-header');
    const footer = document.querySelector('app-footer');

    if (header) {
      this.renderer.removeStyle(header, 'display');
    }

    if (footer) {
      this.renderer.removeStyle(footer, 'display');
    }
  }

  removeLastUrlSegment(url: string): string {
    let urlObj = new URL(url);
    let pathSegments = urlObj.pathname.split('/');
    if (pathSegments.length > 1) {
      pathSegments.pop();
      urlObj.pathname = pathSegments.join('/');
    }
    return urlObj.toString();
  }

  createTracking(email) {
    if (!email) {
      email = this.getDeviceId();
    }

    const uuid = this.idSurvey + '_' + email;

    this.trackingService.get4Uuid(uuid).subscribe(
      res => {
        if (res.status === 'OK') {
          const surveyStatus = res['data'].status;

          if (surveyStatus === 'finished') {
            this.showThankYouModal();
          } else if (surveyStatus === 'started') {
            this.setMessage('Encuesta en progreso, puede continuar.');
          } else {
            this.setMessage('Estado desconocido de la encuesta.');
          }
        }
      },
      err => {
        if (err.status === 404) {
          this.startSurveyTracking(email);
        } else if (err.status === 500) {
          console.error('Error del servidor, intenta más tarde.');
          this.setMessage('Error del servidor, intenta más tarde.');
        } else {
          console.error('Error inesperado:', err);
          this.setMessage('Error inesperado, por favor contacta soporte.');
        }
      }
    );
  }


  confirmFinalizarEncuesta() {
    const lastSection = this.visibleSections[this.visibleSections.length - 1];
    const firstUnansweredQuestionId = this.validateSectionQuestions(lastSection);

    if (firstUnansweredQuestionId) {
      const firstUnansweredElement = document.getElementById(`question-${firstUnansweredQuestionId}`);
      if (firstUnansweredElement) {
        firstUnansweredElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      const messageElement = document.getElementById('error-message');
      if (messageElement) {
        messageElement.innerHTML = 'Por favor, responde todas las preguntas obligatorias antes de finalizar la encuesta.';
        messageElement.style.display = 'block';
      }
    } else {
      if (window.confirm('¿Estás seguro de que deseas enviar la encuesta?')) {
        this.finalizarEncuesta();
      }
    }
  }

  startSurveyTracking(email) {
    if (!email) {
      email = this.getDeviceId();
    }

    const uuid = this.idSurvey + '_' + email;

    const data = {
      survey_id: this.idSurvey,
      uuid: uuid,
      email: email,
      start_time: new Date(),
      end_time: null,
      status: 'started',
    };

    this.trackingService.create(data).subscribe(
      res => {
        this.setMessage('Gracias por iniciar la encuesta!');
        this.restartMessage();
      },
      err => {
        if (err["error"].message === 'Validation error') {
          if (this.typeEmail === 0) {
            this.email = this.getDeviceId(true);
            data.uuid = this.idSurvey + '_' + this.email;
            data.email = this.email;
            this.retryCreateTracking(data);
          } else {
            this.setMessage('Actualizando respuestas de: ' + this.email);
          }
        } else if (err.status === 409) {
          console.error('UUID duplicado, generando uno nuevo');
          this.email = this.getDeviceId(true);
          data.uuid = this.idSurvey + '_' + this.email;
          data.email = this.email;
          this.retryCreateTracking(data);
        } else {
          this.setStatus(err["error"].status);
          this.setMessage(err["error"].message);
        }
        this.restartMessage();
      }
    );
  }

  retryCreateTracking(data) {
    this.trackingService.create(data).subscribe(
      res => {
        this.setMessage('Nuevo UUID creado correctamente.');
        this.restartMessage();
      },
      err => {
        console.error('Error creando nuevo UUID:', err);
      }
    );
  }


  finalizarEncuesta() {

    localStorage.removeItem('surveyAnswers_' + this.email);
    localStorage.removeItem('device_id');

    const data = {
      end_time: new Date(),
      status: 'finished'
    }
    this.trackingService.update(this.idSurvey + '_' + this.email, data).subscribe(
      res => {
        this.setMessage('Gracias por completar la encuesta!');
        this.restartMessage();
        this.showThankYouModal();

      },
      err => {
        this.setStatus(err["error"].status);
        this.setMessage(err["error"].message);
        this.restartMessage();
      }
    )
  }

  showThankYouModal() {
    const thankYouModal = document.getElementById('thankYouModal');
    if (thankYouModal) {
      this.thankYouModalInstance = new bootstrap.Modal(thankYouModal, {
        backdrop: 'static',
        keyboard: false
      });
      this.thankYouModalInstance.show();
    }
  }

  copyToClipboard() {
    const surveyUrlInput = document.getElementById('surveyUrl') as HTMLInputElement;
    surveyUrlInput.select();
    surveyUrlInput.setSelectionRange(0, 99999); // Para dispositivos móviles
    document.execCommand('copy');
    alert('Enlace copiado al portapapeles');
  }

  redirectHome() {
    if (this.thankYouModalInstance) {
      this.thankYouModalInstance.hide(); // Cierra el modal antes de redirigir
    }
    this.router.navigate(['/']);
  }

  get visibleSections() {
    if (this.survey && this.survey.sections) {
      return this.survey.sections.filter((section: any) => !this.hiddenSections.has(section.id) && section.title !== "Glosario de términos");
    } else {
      return [];
    }
  }

  openGlossary() {
    const glossarySection = this.survey.sections.find(section => section.title === "Glosario de términos");
    if (glossarySection) {
      window.open(glossarySection.summary, '_blank');
    }
  }

  initializeHiddenSections() {
    this.linkQuestions.forEach(link => {
      if (link.idtriggersection) {
        this.hiddenSections.add(link.idtriggersection);
      }
    });
  }

  restoreSectionVisibility() {
    Object.keys(this.answers).forEach(questionId => {
      const answerOptions = this.answers[questionId];
      Object.keys(answerOptions).forEach(optionId => {
        const answer = answerOptions[optionId];
        const link = this.linkQuestions.find(l => l.idquestion == questionId && l.idoption == answer.optionId);
        if (link && link.idtriggersection) {
          this.hiddenSections.delete(link.idtriggersection);
        }
      });
    });
  }

  getOneUrlSurvey(url: string) {
    if (url) {
      this.svService.getOneUrl(url)
        .subscribe(
          res => {
            this.survey = res['data'];
            //console.log("survey: ", this.survey);
            this.idSurvey = this.survey.id;

            if (this.survey.idstatus !== 1) {
              this.isSurveyExpired = true;
              this.statusMessage = this.getSurveyStatusMessage(this.survey.idstatus);
              return;
            }

            if (this.survey.enddate) {
              this.enddate = new Date(this.survey.enddate);
              const currentDate = new Date();
              if (currentDate > this.enddate) {
                this.isSurveyExpired = true;
                this.statusMessage = 'Esta encuesta ya ha finalizado.';
                return;
              }
            }

            this.getSvSec4Survey(this.survey);
            this.createTracking(this.email);
          },
          err => console.error(err)
        );
    }
  }

  getSurveyStatusMessage(idstatus: number): string {
    switch (idstatus) {
      case 2:
        return 'Esta encuesta ya ha finalizado.';
      case 3:
        return 'Esta encuesta está en borrador y no está disponible para los usuarios.';
      case 4:
        return 'Esta encuesta está en modo prueba y solo está disponible para pruebas internas.';
      default:
        return 'Estado desconocido de la encuesta.';
    }
  }

  getOneSurvey(id: string) {
    if (id) {
      this.svService.getOne(id)
        .subscribe(
          res => {
            this.survey = res['data'];
            this.getSvSec4Survey(this.survey);
          },
          err => console.error(err)
        );
    }
  }

  getSvSec4Survey(survey: Survey) {
    if (survey) {
      this.svsecService.get4Survey(survey.id.toString())
        .subscribe(
          res => {
            this.svsections = res['data'];
            if (this.svsections.length > 0) {
              this.survey.sections = this.svsections;
              this.getQuestion4Section(this.survey.sections);
            }
            //this.loadData();
          },
          err => console.error(err)
        );
    }
  }

  getQuestion4Section(sections: SvSection[]) {
    sections.forEach((s, i) => {
      this.qService.get4Section(s.id.toString())
        .subscribe(
          res => {
            this.questions = res['data'];
            if (this.questions.length > 0) {
              s.questions = this.questions;
              this.getOptions4Question(s.questions, i);
            }
          },
          err => console.error(err)
        );
    });

  }

  getOptions4Question(question: Question[], i) {
    question.forEach((q, j) => {
      this.optService.get4question(q.id.toString())
        .subscribe(
          res => {
            let temp: Option[] = res['data'];
            if (temp.length > 0) {
              q.options = temp;
              this.getAxis4Options(q.options, j);
              temp = [];
            }
          },
          err => console.error(err)
        );
    });
  }

  getAxis4Options(option: Option[], i) {
    option.forEach((op, j) => {
      this.axService.get4Option(op.id.toString())
        .subscribe(
          res => {
            let temp: Axis[] = res['data'];
            if (temp.length > 0) {
              op.axis = temp;
            }
            temp = [];
          },
          err => console.error(err)
        );
    });
  }

  setStatus(status: number) {
    this.msg.status = status;
    this.hiddenMsg = false;
    this.cdr.detectChanges();
    this.restartMessage();
  }

  setMessage(message: string) {
    this.msg.message = message;
    this.hiddenMsg = false;
    this.cdr.detectChanges();
    this.restartMessage();
  }

  restartMessage() {
    setTimeout(() => {
      this.hiddenMsg = true;
      this.cdr.detectChanges();
    }, 3000);
  }

  createAnswer(idquestion: number, idoptions: number, iddimension: number, idrow: number, idcolumn: number, ans: string, questiontype: number, value: boolean) {
    this.answer = {};
    this.answer.id = null;
    this.answer.idquestion = idquestion;
    this.answer.idsurveyed = this.idSurvey; // deberia de estar relacionado con el id de Encuesta no con el usuario por que el encuestado no tiene cuenta
    this.answer.idoptions = idoptions;

    this.answer.iddimension = iddimension || null;
    this.answer.idrow = idrow || null;
    this.answer.idcolumn = idcolumn || null;
    this.answer.answer = ans.length > 0 ? ans : null;
    this.answer.order = null;
    this.answer.detail = null;
    this.answer.source = null;
    this.answer.savedate = null;
    this.answer.os = this.osName; //obtener el sistema operativo
    this.answer.browser = this.browserName; //obtener el navegador
    this.answer.uuid = this.idSurvey + '_' + this.email;
    this.answer.isActive = true; //deberia ser false para que cuando se finalice la encuesta se cambie todas las respuestas a true y tener registro


    // Lógica para mostrar la sección desencadenada si existe
    const link = this.linkQuestions.find(l => l.idquestion === idquestion && l.idoption === idoptions);

    /* logica para guardar respuestas de forma local */

    if (!this.answers[idquestion]) {
      this.answers[idquestion] = {};
    }

    if (idrow && idcolumn) { //matriz
      if (!this.answers[idquestion]) {
        this.answers[idquestion] = {};
      }
      if (!this.answers[idquestion][idrow]) {
        this.answers[idquestion][idrow] = {};
      }

      if (questiontype === 17) { // Matriz con checkboxes
        if (value) {
          this.answers[idquestion][idrow][idcolumn] = { ans: ans, optionId: idoptions };
        } else {
          delete this.answers[idquestion][idrow][idcolumn];
          this.removeAnswer(idquestion, idoptions, idrow, idcolumn);
        }
      } else { // Matriz con radios (tipo 11)
        // Limpiar cualquier respuesta previa para esta fila
        this.answers[idquestion][idrow] = {};
        // Guardar la nueva respuesta seleccionada
        this.answers[idquestion][idrow][idcolumn] = { ans: ans, optionId: idoptions };
      }
    } else {
      if (questiontype === 3) { // selección múltiple
        if (value) {
          if (!this.answers[idquestion][idoptions]) {
            this.answers[idquestion][idoptions] = { ans: ans, optionId: idoptions };
            this.createNewAnswer(this.answer);
            if (link && link.idtriggersection) {
              this.hiddenSections.delete(link.idtriggersection);
            }
          }
        } else {
          delete this.answers[idquestion][idoptions];
          this.removeAnswer(idquestion, idoptions, null, null);
          if (link && link.idtriggersection) {
            this.hiddenSections.add(link.idtriggersection);
          }
        }
      } else { //politomica
        // Eliminar las secciones que se mostraron anteriormente
        Object.keys(this.answers[idquestion]).forEach(optionId => {
          const previousLink = this.linkQuestions.find(l => l.idquestion === idquestion && l.idoption === Number(optionId));
          if (previousLink && previousLink.idtriggersection) {
            this.hiddenSections.add(previousLink.idtriggersection);
          }
        });
        if (questiontype === 1) { //politomica
          this.answers[idquestion] = { [idoptions]: { ans: ans, optionId: idoptions } };
        } else {
          // Aquí almacenamos múltiples respuestas en el caso de texto simple
          this.answers[idquestion][idoptions] = { ans: ans, optionId: idoptions };
        }

        if (link && link.idtriggersection) {
          this.hiddenSections.delete(link.idtriggersection);
        }
      }
    }

    // Guardar en localStorage
    try {
      localStorage.setItem('surveyAnswers_' + this.email, JSON.stringify(this.answers));
    } catch (error) {
      console.error('Error al guardar respuestas:', error);
    }

    /*if (questiontype === 1) { // politomica
      this.handleAnswerCheck(idquestion, null, null);
    } else if (questiontype === 9 || questiontype === 7 || questiontype === 13 || questiontype === 14 || questiontype === 15) { // texto
      this.handleAnswerCheck(idquestion, idoptions, null);
    } else if (questiontype === 11) { // matriz
      this.handleAnswerCheck(idquestion, idoptions, idrow);
    }*/

    if(questiontype === 11){
      this.handleAnswerCheck(idquestion, idoptions, idrow, null);
    }else if (questiontype === 1 || questiontype === 17) {
      this.handleAnswerCheck(idquestion, idoptions, idrow, idcolumn);
    } else if (questiontype === 9 || questiontype === 7 || questiontype === 13 || questiontype === 14 || questiontype === 15) {
      this.handleAnswerCheck(idquestion, idoptions, null, null);
    }

    // Mostrar u ocultar la sección desencadenada si existe
    if (value === undefined || value) { // Se valida si la pregunta es politómica o selección múltiple
      if (link && link.idtriggersection) {
        this.showSection(link.idtriggersection);
      }
    } else if (value === false && link && link.idtriggersection) {
      this.hideSection(link.idtriggersection);
    }
  }

  validateMatrixQuestion(question: any): boolean {
    let isValid = true;

    question.options.forEach(option => {
      option.axis.forEach(row => {
        if (row.type === 1) { // Validar solo filas
          const rowHasSelection = Object.keys(this.answers[question.id] || {}).some(col => {
            return this.answers[question.id][row.id]; // Revisar si hay alguna respuesta en la fila
          });

          const rowElement = document.getElementById(`row-${question.id}-${row.id}`);

          if (!rowHasSelection && rowElement) {
            isValid = false; // Marcar como no válida si no tiene selección
            rowElement.classList.add('row-required'); // Resaltar la fila en rojo
          } else if (rowElement) {
            rowElement.classList.remove('row-required'); // Remover resaltado si está respondida
          }
        }
      });
    });

    return isValid;
  }


  showSection(sectionId: number) {
    const sectionIndex = this.survey.sections.findIndex(s => s.id === sectionId);
    if (sectionIndex !== -1) {
      //this.currentSectionIndex = sectionIndex;
    }
  }

  hideSection(sectionId: number) {
    this.hiddenSections.add(sectionId);
    const sectionIndex = this.survey.sections.findIndex(s => s.id === sectionId);
    if (sectionIndex !== -1 && !this.hiddenSections.has(sectionId)) {
      this.currentSectionIndex = sectionIndex > 0 ? sectionIndex - 1 : 0;
    }
  }

  removeAnswer(idquestion: number, idoptions: number | null, idrow: number | null, idcolumn: number | null) {
    this.answerService.checkIfExists(idquestion, this.idSurvey, idoptions, this.idSurvey + '_' + this.email, idrow, idcolumn).subscribe(
      res => {
        if (res.exists) {
          this.answerService.delete(res.id).subscribe(
            res => {
              this.setMessage('Respuesta eliminada');
            },
            err => {
              this.setStatus(err["error"].status);
              this.setMessage(err["error"].message);
            }
          );
        }
      }
    );

  }

  private answerExistsInDB(idquestion: number, idoptions: number, idrow: number | null, idcolumn: number | null): boolean {
    // Verifica primero en las respuestas locales
    if (this.answers[idquestion]) {
      if (idrow !== null) {
        if (this.answers[idquestion][idrow] && this.answers[idquestion][idrow][idcolumn]) {
          return true;
        }
      } else if (this.answers[idquestion][idoptions]) {
        return true;
      }
    }
    return false;
  }

  private handleAnswerCheck(idquestion: number, idoptions: number | null, idrow: number | null, idcolumn: number | null) { //verifica las respuestas
    this.answerService.checkIfExists(idquestion, this.idSurvey, idoptions, this.idSurvey + '_' + this.email, idrow, idcolumn).subscribe(
      res => {
        if (res.exists) {
          this.updateAnswer(res.id, this.answer);
        } else {
          this.createNewAnswer(this.answer);
        }
      },
      err => {
        this.handleError(err);
      }
    );
  }

  handleError(err: any) {
    this.setStatus(err["error"].status);
    this.setMessage(err["error"].message);
    this.restartMessage();
  }

  updateAnswer(id: number, answer: Answer) {
    this.answerService.update(id, answer).subscribe(
      res => {
        this.setMessage('Respuesta actualizada');
      },
      err => {
        this.setStatus(err["error"].status);
        this.setMessage(err["error"].message);
      }
    );
  }

  createNewAnswer(answer: Answer) {
    this.answerService.create(answer).subscribe(
      res => {
        this.setStatus(res['status']);
        this.setMessage('Respuesta guardada');
        this.restartMessage();
      },
      err => {
        this.setStatus(err["error"].status);
        this.setMessage(err["error"].message);
        this.restartMessage();
      }
    );
  }


  getBrowserName() {
    const userAgent = navigator.userAgent;
    let browserName = 'Unknown Browser';

    if (/firefox|fxios/i.test(userAgent)) {
      browserName = 'Firefox';
    } else if (/edg/i.test(userAgent)) {
      browserName = 'Edge';
    } else if (/opr\//i.test(userAgent)) {
      browserName = 'Opera';
    } else if (/chrome|crios/i.test(userAgent) && !/edg/i.test(userAgent)) {
      browserName = 'Chrome';
    } else if (/safari/i.test(userAgent) && !/chrome|crios|edg/i.test(userAgent)) {
      browserName = 'Safari';
    } else if (/trident/i.test(userAgent)) {
      browserName = 'Internet Explorer';
    }
    this.browserName = browserName;
  }

  getOsName() {
    const userAgent = window.navigator.userAgent;
    let osName = 'Desconocido';

    if (userAgent.indexOf('Win') !== -1) {
      osName = 'Windows';
    } else if (userAgent.indexOf('Mac') !== -1) {
      osName = 'macOS';
    } else if (userAgent.indexOf('Linux') !== -1) {
      osName = 'Linux';
    } else if (userAgent.indexOf('Android') !== -1) {
      osName = 'Android';
    } else if (userAgent.indexOf('iOS') !== -1) {
      osName = 'iOS';
    }

    this.osName = osName;
  }

  getAnswer(questionId: number, optionId: number): string {
    const answer = this.answers[questionId] ? this.answers[questionId][optionId] : null;
    if (answer && typeof answer === 'object' && answer.ans) {
      return answer.ans;
    }
    return '';
  }

  isChecked(questionId: number, optionId: number): boolean {
    return this.answers[questionId] && this.answers[questionId][optionId] !== undefined;
  }

  isCheckedMatrix(questionId: number, rowId: number, colId: number): boolean {
    return this.answers[questionId] &&
      this.answers[questionId][rowId] &&
      this.answers[questionId][rowId][colId] !== undefined;
  }

  goToPreviousSection() {
    if (this.currentSectionIndex > 0) {
      this.currentSectionIndex--;
    }
  }

  validateSectionQuestions(section): number | null {
    let firstUnansweredQuestionId = null;

    section.questions.forEach(q => {
      const questionElement = document.getElementById(`question-${q.id}`);
      let isValid = true;

      if (q.idquestiontype === 11 && q.isRequired) {
        isValid = this.validateMatrixQuestion(q);
      } else if (q.idquestiontype === 17 && q.isRequired) {
        isValid = this.validateCheckboxMatrixQuestion(q);
      } else if (q.idquestiontype === 9 && q.isRequired && this.isEmptyAnswer(q.id)) {
        isValid = false;
      } else if (q.idquestiontype === 7 && q.isRequired && this.isEmptyOrInvalidNumber(q.id)) {
        isValid = false;
      } else if (q.isRequired && !this.hasAnswer(q.id)) {
        isValid = false;
      }

      if (!isValid) {
        if (!firstUnansweredQuestionId) {
          firstUnansweredQuestionId = q.id;
        }
        if (questionElement) {
          questionElement.classList.add('question-required');
        }
      } else if (questionElement) {
        questionElement.classList.remove('question-required');
      }
    });

    return firstUnansweredQuestionId;
  }

  validateCheckboxMatrixQuestion(question: any): boolean {
    // Para matrices de checkboxes, validamos que al menos una opción esté seleccionada
    // en cada fila si es requerido
    let isValid = true;

    question.options.forEach(option => {
      option.axis.forEach(row => {
        if (row.type === 1 && question.isRequired) { // Solo filas
          const rowHasSelection = this.answers[question.id] &&
                                this.answers[question.id][row.id] &&
                                Object.keys(this.answers[question.id][row.id]).length > 0;

          const rowElement = document.getElementById(`row-${question.id}-${row.id}`);

          if (!rowHasSelection && rowElement) {
            isValid = false;
            rowElement.classList.add('row-required');
          } else if (rowElement) {
            rowElement.classList.remove('row-required');
          }
        }
      });
    });

    return isValid;
  }


  goToNextSection() {
    const currentSection = this.visibleSections[this.currentSectionIndex];
    const firstUnansweredQuestionId = this.validateSectionQuestions(currentSection);

    if (firstUnansweredQuestionId) {
      const firstUnansweredElement = document.getElementById(`question-${firstUnansweredQuestionId}`);
      if (firstUnansweredElement) {
        firstUnansweredElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      const messageElement = document.getElementById('error-message');
      if (messageElement) {
        messageElement.innerHTML = 'Por favor, responde todas las preguntas obligatorias.';
        messageElement.style.display = 'block';
      }
    } else {
      if (this.currentSectionIndex < this.visibleSections.length - 1) {
        this.currentSectionIndex++;

        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // Desplazamiento suave al inicio
          });
        }, 0);

        const messageElement = document.getElementById('error-message');
        if (messageElement) {
          messageElement.style.display = 'none';
        }
      }
    }
  }


  isEmptyOrInvalidNumber(questionId: number): boolean {
    const answers = this.answers[questionId];
    if (!answers) return true;

    return Object.keys(answers).every(key => {
      const answerValue = answers[key].ans;
      return !answerValue || isNaN(Number(answerValue)) || Number(answerValue) <= 0;
    });
  }


  isEmptyAnswer(questionId: number): boolean {
    const answers = this.answers[questionId];
    return !answers || Object.keys(answers).every(key => !answers[key].ans || answers[key].ans.trim() === '');
  }

  hasAnswer(questionId: number): boolean {
    return this.answers[questionId] && Object.keys(this.answers[questionId]).length > 0;
  }


  openGlossaryModal() {
    this.showModal = true;
    this.toggleMessages(false);
  }

  closeGlossaryModal() {
    this.showModal = false;
  }

  isGlossaryAvailable(): boolean {
    return this.survey && this.survey.sections && !!this.survey.sections.find(section => section.title === "Glosario de términos");
  }

  modalTitle = '';
  safeHtmlContent: SafeHtml = '';
  showDetail(title: string, htmlContent: string) {
    if (!htmlContent) return;

    this.modalTitle = title || 'Detalles';
    this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(htmlContent);

    const modal = new bootstrap.Modal(document.getElementById('detailModal'));
    modal.show();
  }

}
